module.exports = __webpack_public_path__ + "img/ymddgwdyh.96046db1.jpg";